
















































import { Vue, Component, Prop } from "vue-property-decorator";

export interface FolderNode {
    id: string;
    name: string;
    type: "folder" | "file";
    children: FolderNode[];
    expanded: boolean;
    loading: boolean;
    loaded: boolean;
}

@Component({
    name: "FolderTreeNode"
})
export default class FolderTreeNode extends Vue {
    @Prop({ required: true }) public node!: FolderNode;
    @Prop({ default: null }) public selectedId!: string | null;
    @Prop({ default: false }) public folderOnly!: boolean;

    public get isFolder(): boolean {
        return this.node.type === "folder";
    }

    public get isSelected(): boolean {
        return this.node.id === this.selectedId;
    }

    public toggle(): void {
        if (!this.isFolder) {
            return;
        }
        this.$emit("toggle", this.node);
    }
}
